import { Instant } from "@js-joda/core";
import React from "react";
import { API } from "../API";
import {
  PatientDocumentTypeId,
  PlanOfCareItemId,
  RequiredDutySheetTask,
  VisitInstanceId,
} from "../messages";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { List } from "../utils/List";
import DutyTasksList from "./Timesheet/components/DutyTasksList";
import { SelectedDutyTasks } from "./Timesheet/useTimesheetForm";

interface Props {
  isDutySheetCompleted: boolean;
  postPatientDocAnswer: API["postPatientDocAnswer"];
  requiredDutyTasks: List<RequiredDutySheetTask>;
  selectedDutyTasks: SelectedDutyTasks;
  visitInstanceId: VisitInstanceId;
  onCheckTask: (id: PlanOfCareItemId, isChecked: boolean) => void;
  onChangeNotes: (id: PlanOfCareItemId, notes: string | null) => void;
  onRequestOpenErrorModal: (errorMessage: string) => void;
  onOpenChangesSavedBanner: () => void;
}

const DutySheetActivity = (props: Props) => {
  const dutySheetDocument = PatientDocumentTypeId.wrap(-12345); // TODO: Update to new dutysheet

  const updateDutySheetTask = async (taskId: PlanOfCareItemId, isChecked: boolean) => {
    props.onCheckTask(taskId, isChecked);
    await props.postPatientDocAnswer(props.visitInstanceId, dutySheetDocument, {
      answer: isChecked ? ["Done"] : [],
      chartRow: -1,
      questionId: Number.parseInt(taskId.toString(), 10),
      createdAt: Instant.now(),
    });

    props.onOpenChangesSavedBanner();
  };

  const updateDutySheetTaskNotes = async (taskId: PlanOfCareItemId, notes: string) => {
    props.onChangeNotes(taskId, notes);
    await props.postPatientDocAnswer(props.visitInstanceId, dutySheetDocument, {
      answer: notes,
      chartRow: -1,
      questionId: Number.parseInt(taskId.toString(), 10) + 1000,
      createdAt: Instant.now(),
    });

    props.onOpenChangesSavedBanner();
  };

  const handleDisabledItemClick = () => {
    props.onRequestOpenErrorModal(translate(STRINGS.UNABLE_TO_EDIT_SUBMITTED_DUTY_SHEET));
  };

  return (
    <DutyTasksList
      duties={props.requiredDutyTasks}
      selectedDutyTasks={props.selectedDutyTasks}
      onChangeNotes={updateDutySheetTaskNotes}
      onCheck={updateDutySheetTask}
      isTaskItemDisabled={props.isDutySheetCompleted}
      onDisabledTaskItemClick={handleDisabledItemClick}
    />
  );
};

export default DutySheetActivity;
